var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('t-caspanel',{ref:"caspanel",attrs:{"prefix-class":_vm.prefixCardClass,"data":_vm.dataSource,"disabled":_vm.disabled,"change-on-select":_vm.changeOnSelect,"size":_vm.size,"filterable":_vm.filterable,"clearable":_vm.clearable}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42edc1d0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/cascader/cascader.vue
// module id = 694
// module chunks = 0 1 7